/* eslint-disable import/no-anonymous-default-export */

const API_URL = "https://api.kasbah-magic.com/conciergeLastVersion/index.php?action=";
const BASE_URL = "https://api.kasbah-magic.com/conciergeLastVersion/";

// const API_URL = "https://kasba.sa-pub.com/conciergeLastVersion/index.php?action=";
// const BASE_URL = "https://kasba.sa-pub.com/conciergeLastVersion/";

export default {
  API_URL,
  BASE_URL
};
